import NewsitemScreen from './containers/newsitemScreen'

export {default as NewsitemScreenLayout} from './components/newsitemScreenLayout'

export default NewsitemScreen
